import {
  boardAttributes,
  SinglePieceChessBoardType,
} from '../../../constants/EntertainmentGames/singlePieceChessBoard';
import { GridShape, GridShapeProps } from '../GridShape';

interface SingleChessBoardViewProps {
  boardImageSource?: string;
  boardType: SinglePieceChessBoardType;
  width: number;
  height: number;
  rows: number;
  columns: number;
}

export const SingleChessBoardView = (props: SingleChessBoardViewProps) => {
  const { boardImageSource, boardType, rows, columns } = props;

  const { imageSource, strokeColor } = boardAttributes[boardType];

  const gridShapeProps: GridShapeProps = {
    rows,
    columns,
    strokeColor,
    strokeWidth: 1,
    // width,
    // height,
    dots: [],
  };

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <img
        src={imageSource}
        alt={`Chess board ${boardType}`}
        style={{ width: '100%', height: '100%' }}
      />
      <img
        src={boardImageSource}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: 0.4,
        }}
      />

      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <GridShape {...gridShapeProps} />
      </div>
    </div>
  );
};
